export type SweetSpotTermKey =
  | 'rq'
  | 'cq'
  | 'ssi'
  | 'normalization'
  | 'positiveIndicator'
  | 'negativeIndicator'
  | 'recommendedWeight'
  | 'customWeight'
  | 'ahp'
  | 'gradeThreshold'
  | 'dataCoverage'
  | 'validSample';

export type SweetSpotTerm = {
  title: string;
  summary: string;
  detail?: string;
};

export const SWEETSPOT_TERMS: Record<SweetSpotTermKey, SweetSpotTerm> = {
  rq: {
    title: '储层品质 RQ',
    summary: '表征评价井段储层地质条件的 0～1 评分，由已启用的 RQ 评价指标按当前权重方案计算。',
    detail: '输入数据、指标方向和指标权重以当前评价配置为准。',
  },
  cq: {
    title: '工程品质 CQ',
    summary: '表征评价井段压裂改造条件的 0～1 评分，由已启用的 CQ 评价指标按当前权重方案计算。',
    detail: '输入数据、指标方向和指标权重以当前评价配置为准。',
  },
  ssi: {
    title: '甜点指数 SSI',
    summary: '按 SSI = 0.5 RQ + 0.5 CQ 合成 0～1 评分，并映射为甜点等级。',
  },
  normalization: {
    title: '指标标准化',
    summary: '将不同量纲的评价指标转换为可组合的 0～1 评分。',
    detail: '标准化范围或目标区间由当前评价配置确定。',
  },
  positiveIndicator: {
    title: '正向指标',
    summary: '原始值增大时，标准化评分随之提高的指标。',
  },
  negativeIndicator: {
    title: '负向指标',
    summary: '原始值增大时，标准化评分随之降低的指标。',
  },
  recommendedWeight: {
    title: '预设权重',
    summary: '采用系统内置的标准工程权重，适合按统一口径快速评价。',
    detail: '预设权重只读；切换到自定义权重后可手动录入。',
  },
  customWeight: {
    title: '自定义权重',
    summary: '由用户直接录入各评价指标权重，RQ 与 CQ 分别自动归一化。',
    detail: '系统会保留本次录入值，切换赋权方式后仍可恢复。',
  },
  ahp: {
    title: '层次分析（AHP）',
    summary: '通过两两比较生成权重，并用一致性指标判断是否可用。',
    detail: '是否应用权重由一致性与参数维度共同决定。',
  },
  gradeThreshold: {
    title: '等级阈值',
    summary: '用于把连续 SSI 映射为等级分界值。',
  },
  dataCoverage: {
    title: '数据覆盖率',
    summary: '评价井段内满足相应指标数据要求的采样点占比，用于说明数据完整程度。',
  },
  validSample: {
    title: '有效采样点',
    summary: '满足 SSI 输入与计算条件、可形成有效评价结果的深度采样点。',
  },
};
